import { SeoItem } from './interfaces';

export const SEO_ITEMS: Array<SeoItem> = [
  {
    order: 0,
    title:
      'Shop Alcohol Online in Dubai & Abu Dhabi – Fast & Reliable Alcohol Delivery',
    captions: [
      'CityDrinks brings you the best alcohol delivery service in the UAE. Whether you need fine wines, premium spirits, or craft beers, we deliver straight to your doorstep in Abu Dhabi & Dubai. At CityDrinks, we’re more than just an online liquor store — we’re your go-to destination for premium drinks, perfect for any occasion. From casual get-togethers to grand celebrations, enjoy fast, hassle-free alcohol delivery with the best selection in town. Cheers to convenience, premium choices, and exceptional service — all with CityDrinks, your trusted alcohol retailer in the UAE.',
    ],
  },
  {
    icon: 'flash',
    order: 1,
    title: 'Lightning-Fast Delivery',
    caption:
      'Get your drinks under 2 hours, with some orders eligible to arrive within 15 minutes.',
  },
  {
    icon: 'file-box',
    order: 2,
    title: 'On-Hand Stocks',
    caption:
      'We take pride in offering the most reliable stock availability, because frankly, no one likes an empty glass.',
  },
  {
    icon: 'present',
    order: 3,
    title: 'Premium, But Not Pricey',
    caption:
      'Top-shelf drinks for the friendliest price. Unlock even more savings when you shop via our app!',
  },
];

export const SEO_ITEMS_DE: Array<SeoItem> = [
  {
    order: 0,
    title: 'Товар из Объединённых Арабских Эмиратов',
    captions: [
      'Уважаемый покупатель!',
      'ㅤ',
      'Наш магазин расположен в свободной экономической зоне международного аэропорта Дубая - DAFZA. Товары здесь не облагаются местными налогами и пошлинами - их можно выгодно заказать и быстро получить с авиадоставкой в Россию.',
      'ㅤ',
      'При этом российская таможенная пошлина в цену товара на Озон не включена. Положите товар в корзину - там будет показана сумма пошлины. Озон возьмёт её сразу при оплате заказа, и пошлину не придётся отдельно оплачивать.',
      'ㅤ',
      'Приятных покупок!',
      'Команда Dubai Duty Free',
    ],
  },
  {
    icon: 'certificate',
    order: 1,
    title: 'Оригинальные товары',
    caption: 'Подлиность товаров подтверждена сертификатами',
  },
  {
    icon: 'plane',
    order: 2,
    title: 'Надёжная доставка',
    caption: 'Заботимся о качестве и скорости доставки прямо из Дубая',
  },
  {
    icon: 'sale',
    order: 3,
    title: 'Выгодные цены',
    caption: 'Работаем напрямую со складами и поддерживаем низкие цены',
  },
];
